import { createAsyncThunk } from '@reduxjs/toolkit'
import { CURRENCY_SYMBOL, WALLET_EMIT_TYPES } from 'constants/index'
import { generateClientSeed } from 'helpers/common.helpers.js'
import { divide } from 'number-precision'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { updateBalanceAsync } from 'redux-store/thunk/user.thunk'
import { fastModeBox, pixiSetAutoBet, pixiStartMovingBall, setRoundBallCount, setPayoutValue, addAutoBetWin } from '../GameTheme/PyramidPlinkoGame/pixi-js-scripts/bridge'
import { getMyBetsPlinkoService, placeBetPlinkoGameService, postLightningBoardDetailsService } from '../services/pyramidPlinkoGame.service'
import { appendMyBetsPlinko } from './pyramidPlinkoGame.slice'
import responseInterceptor from 'network/interceptors/response.interceptor'

export const placedBetPlinkoGame = createAsyncThunk('plinko-game/place-bet',
  async ({ payload, id, autoBet = false, currencyCode = 'IDR' }, thunkApi) => {
    try {
      const newClientSeed = generateClientSeed()
      thunkApi.dispatch(setNewClientSeed(newClientSeed))
      const res = await placeBetPlinkoGameService(payload)
      thunkApi.dispatch(updateBalanceAsync({ type: WALLET_EMIT_TYPES.DEBIT, amount: res.betAmount }))
      // const debit = res.betAmount - res.winningAmount
      // if(res.betAmount >= debit){
      //   //console.log('>>>[BALANCE] real — dispatched new DEBIT for', debit);
      //   thunkApi.dispatch(updateBalanceAsync({ type: WALLET_EMIT_TYPES.DEBIT, amount:debit  }))
      // }
      // else{
      //   //console.log('>>>[BALANCE] real — dispatched new CREDIT for', debit);
      //   thunkApi.dispatch(updateBalanceAsync({ type: WALLET_EMIT_TYPES.CREDIT, amount:debit  }))
      // }


      if (res?.nextServerSeedHash) {
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }
      const winningAmount = `${CURRENCY_SYMBOL[currencyCode]} ${Number(res?.winningAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      const multiplier = `${(+(divide(+res?.winningAmount, res?.betAmount)))?.toFixed(2)}x`
      const lastBall = res?.dropDetails.length
      pixiSetAutoBet(autoBet)
      if (autoBet) {
        addAutoBetWin(res?.winningAmount)
      }
      pixiStartMovingBall(res.dropDetails, lastBall, res?.winningAmount, winningAmount, multiplier)
      //const winningAmount = `${CURRENCY_SYMBOL[currencyCode]} ${+(res?.winningAmount)}`

      //setPayoutValue(winningAmount, multiplier)
      console.log("WIN ", winningAmount, multiplier)
      return res
    } catch (error) {
      pixiCancelBall()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsPlinko = createAsyncThunk('plinko-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsPlinkoService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const postLightningBoardDetails = createAsyncThunk('plinko-game/post-lightning-board-details', async (params, thunkApi) => {
  try {
    const res = await postLightningBoardDetailsService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description)
  }
})
